import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const propertyInfoConfig = {
  // Verify token from URL
  verifyToken: {
    key: "verifyToken",
    url: (params) => `/api/v1/property-compliance/validate-token?token=${params.token}`,
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
      retry: false,
    },
  },

  // Get document types from database enum
  getDocumentTypes: {
    key: "getDocumentTypes",
    url: "/api/v1/property-compliance/document-types",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
    },
  },

  // Get compliance for review by uniqueCode (for PMS staff review page)
  getComplianceDocsForReview: {
    key: "getComplianceDocsForReview",
    url: (params) => `/api/v1/property-compliance/by-code/${params.uniqueCode}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.REALTIME,
      retry: false,
    },
  },

  // Get compliance for reupload (token-based, no auth required)
  getComplianceForReupload: {
    key: "getComplianceForReupload",
    url: (params) => `/api/v1/property-compliance/reupload?token=${params.token}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.REALTIME,
      retry: false,
    },
  },

  // Submit property compliance documents
  submitCompliance: {
    key: "submitCompliance",
    url: "/api/v1/property-compliance/submit",
    method: "POST",
    options: {
      invalidateKeys: [
        "getDocumentTypes",
        "getComplianceDocsForReview",
        "getComplianceForReupload",
        "getComplianceByRegUserId",
        "getPendingCompliance",
      ],
    },
  },

  // Reupload rejected documents
  reuploadDocuments: {
    key: "reuploadDocuments",
    url: "/api/v1/property-compliance/reupload",
    method: "POST",
    options: {
      invalidateKeys: [
        "getComplianceDocsForReview",
        "getComplianceByRegUserId",
        "getPendingCompliance",
      ],
    },
  },
};
